<template lang="html">
  <div id="home-page">

    <section class="banners-section">
      <swiper class="swiper desktop" :options="bannersOptions">
        <swiper-slide v-for="banner_pc in banners.pc" :key="banner_pc.id">
          <img class="placed-backg" src="public/images/pages/home/banner.png" v-bind:style="{ backgroundImage: 'url('+banner_pc.imagen+')' }">
          <!--img class="placed-backg" src="public/images/pages/home/banner.png" v-bind:style="{ backgroundImage: 'url(public/images/pages/home/banner-1.jpg)' }"-->
        </swiper-slide>
      </swiper>

      <swiper class="swiper mobile" :options="bannersOptions">
        <swiper-slide v-for="banner_movil in banners.movil" :key="banner_movil.id">
          <img class="placed-backg" src="public/images/pages/home/banner-m.png" v-bind:style="{ backgroundImage: 'url('+banner_movil.imagen+')' }">
          <!--img class="placed-backg" src="public/images/pages/home/banner-m.png" v-bind:style="{ backgroundImage: 'url(public/images/pages/home/banner-1-m.jpg)' }"-->
        </swiper-slide>
      </swiper>
    </section>

    <section class="container-fluid jobusco-options-section">
      <div class="row">
        <div class="placed-backg col-lg-6 col-option usuario">
          <div class="box">
            <h4>JOBUSCO EMPLEO</h4>
            <h5>Crea tu curriculum en línea
              y mantente visible para las empresas.
            </h5>

            <p class="mt-3">
              <a class="trans-250 btn-cur-1 lg bg-white" @click="openedModal = 'loginuser'">Ingresa</a>
            </p>
          </div>
        </div>

        <div class="placed-backg col-lg-6 col-option empresa">
          <div class="box">
            <h4>JOBUSCO PERSONAL</h4>
            <h5>Publica tus vacantes y busca en la
              base de datos los perfiles más adecuados.
            </h5>

            <p class="mt-3">
              <a class="trans-250 btn-cur-1 lg bg-white" @click="openedModal = 'loginemployer'">Ingresa</a>
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="latest-jobs">
      <div class="container">
        <div class="box-titles">
          <h2 class="title">EMPLEOS RECIENTES</h2>
          <h5 class="subtitle">el que busca, encuentra</h5>
        </div>

        <div class="row box-jobs">
          <div class="col-lg-6 col-jobs-s1" v-for="(job, hjbInx) in jobs" :key="'hjbInx-'+hjbInx">

            <router-link class="box" :to="'/empleos/'+job.id">
              <div class="col col-logo">
                <img :src="job.empresa_imageUrl">
              </div>

              <div class="col col-info">
                <h4 class="title" style="font-family:sans-serif !important">{{ job.nombre }}</h4>
                <h5 class="company" style="font-family:sans-serif !important">{{ job.empresa }}</h5>
                <h5 class="location">{{ job.ciudad }}, {{ job.estado }}.</h5>
              </div>

              <div class="col col-time">
                <h6 class="date">{{ job.fecha }}</h6>
                <span class="type completo" v-bind:style="{ backgroundColor: job.typeColor }">{{ job.sueldo }}</span>
              </div>
            </router-link>
          </div>

          <div class="col-12 col-more">
            <router-link class="trans-250 btn-cur-1 lg" to="/empleos">Ver más</router-link>
          </div>
        </div>
      </div>
    </section>

    <section class="sectors-section">
      <div class="container oversized-container">
        <div class="box-titles">
          <h2 class="title">SECTORES PRINCIPALES</h2>
          <h5 class="subtitle">el que busca, encuentra</h5>
        </div>

        <div class="box-sectors">
          <swiper class="swiper" :options="sectorsOptions">
            <swiper-slide >
              <div class="box-sector">
                <div class="box-icon">
                  <img :src="sectors[0].img">
                </div>

                <div class="box-descr">
                  <h5>{{ sectors[0].title }}</h5>
                  <h5>{{ this.$root.extras.adminstracion}}</h5>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide >
              <div class="box-sector">
                <div class="box-icon">
                  <img :src="sectors[1].img">
                </div>

                <div class="box-descr">
                  <h5>{{ sectors[1].title }}</h5>
                  <h5>{{ this.$root.extras.ventas}}</h5>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide >
              <div class="box-sector">
                <div class="box-icon">
                  <img :src="sectors[2].img">
                </div>

                <div class="box-descr">
                  <h5>{{ sectors[2].title }}</h5>
                  <h5>{{ this.$root.extras.salud}}</h5>
                </div>
              </div>
            </swiper-slide>

            <swiper-slide >
              <div class="box-sector">
                <div class="box-icon">
                  <img :src="sectors[2].img">
                </div>

                <div class="box-descr">
                  <h5>{{ sectors[3].title }}</h5>
                  <h5>{{ this.$root.extras.educacion}}</h5>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide >
              <div class="box-sector">
                <div class="box-icon">
                  <img :src="sectors[4].img">
                </div>

                <div class="box-descr">
                  <h5>{{ sectors[4].title }}</h5>
                  <h5>{{ this.$root.extras.atencion}}</h5>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide >
              <div class="box-sector">
                <div class="box-icon">
                  <img :src="sectors[5].img">
                </div>

                <div class="box-descr">
                  <h5>{{ sectors[5].title }}</h5>
                  <h5>{{ this.$root.extras.auto}}</h5>
                </div>
              </div>
            </swiper-slide>
            
          </swiper>
        </div>

        <div class="box-more">
          <router-link class="trans-250 btn-cur-1 lg" to="/empleos">Buscar todo</router-link>
        </div>
      </div>
    </section>

    <!-- Modal login -->
    <modallogin-component></modallogin-component>
    <!-- Modal reset password -->
    <modalresetpass-component></modalresetpass-component>
    <!--  -->

  </div>
</template>

<script>
import modalloginComponent from './shared/modals/modal-login.vue';
import modalresetpassComponent from './shared/modals/modal-reset-password.vue';
export default {
  data(){
    return{
      jobs: [
        /*{ img: 'public/images/pages/jobs/logo-1.png', title: 'Ejecutivo de Cuenta', company: 'Insumos Quirúrgicos', type: 'Tiempo completo', typeColor: '#0e447b' },
        { img: 'public/images/pages/jobs/logo-2.png', title: 'Agente Inmobiliario', company: 'Blue Capital', type: 'Freelance', typeColor: '#d8248e' },
        { img: 'public/images/pages/jobs/logo-3.png', title: 'Distribuidor', company: 'Café Colibrí Artesanal', type: 'Tiempo completo', typeColor: '#0e447b' },
        { img: 'public/images/pages/jobs/logo-1.png', title: 'Recepcionista', company: 'Insumos Quirúrgicos', type: 'Tiempo completo', typeColor: '#0e447b' },
        { img: 'public/images/pages/jobs/logo-4.png', title: 'Estilista Canino', company: 'Happy Friends, Estética', type: 'Temporal', typeColor: '#ba0f48' },
        { img: 'public/images/pages/jobs/logo-5.png', title: 'Recepcionista', company: 'Inntralasik', type: 'Medio tiempo', typeColor: '#f1630d' },
        { img: 'public/images/pages/jobs/logo-6.png', title: 'Arquitecto', company: 'Promso Constructora', type: 'Tiempo completo', typeColor: '#0e447b' },
        { img: 'public/images/pages/jobs/logo-7.png', title: 'Vendedor de Mostrador', company: 'Ganesh, Té de Cacao', type: 'Tiempo completo', typeColor: '#0e447b' },*/
      ],

      sectors: [
        { img: 'public/images/pages/jobs/icon-1.png', title: 'Administración',text:'' },
        { img: 'public/images/pages/jobs/icon-2.png', title: 'Ventas',text:'' },
        { img: 'public/images/pages/jobs/icon-3.png', title: 'Salud',text:'' },
        { img: 'public/images/pages/jobs/icon-4.png', title: 'Educación',text:'' },
        { img: 'public/images/pages/jobs/icon-5.png', title: 'Atención al cliente',text:'' },
        { img: 'public/images/pages/jobs/icon-6.png', title: 'Auto agencias',text:'' },
      ],

      // == Carousel options ==
      bannersOptions: {
        effect: 'fade',

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },

      sectorsOptions: {
        slidesPerView: 6,
        spaceBetween: 30,

        breakpoints: {
          1490: {
            slidesPerView: 6
          },
          1200: {
            slidesPerView: 5,
            spaceBetween: 20,
          },
          992: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          425: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          1: {
            slidesPerView: 1
          },
        }
      },
      // == ==
      banners:[],
      openedModal:null
    }
  },
  methods:{
    getBanners(){
        axios.get(tools.url("/bannersFront")).then((response)=>{
          this.banners=response.data;
        }).catch((error)=>{
        });
    },
    getVacanciesRecently(){
        axios.get(tools.url("/vacanciesRecently")).then((response)=>{
          this.jobs=response.data;
        }).catch((error)=>{
        });
    },
    

  },
  components: {
    modalloginComponent,modalresetpassComponent
  },
  mounted() {

      this.getBanners();
      this.getVacanciesRecently();
       
  }
}
</script>
